import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBannerSlide } from '../components/banner-slides/contracts/interfaces/banner-slide.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiComunicadosAggerHubService {
  private http = inject(HttpClient);

  public getComunicados(): Observable<IBannerSlide[]> {
    const url = `https://json.agger.com.br/json/comunicados.json?v=${new Date().getTime()}`;
    return this.http.get<IBannerSlide[]>(url);
  }
}